
  <div class="filterOptions">
<div class="titleIcon"> 
    <h3 class="clsCard_Title">
      {{ 'component.security.title' | translate }}
    </h3>

   <div class="filterIcon" >
   <div class="clsFiltersBtn" (click)="toogleVarFilter()">
     <img
       src="../../../../assets/images/icons/icon-filter.svg"
       width="30"
       height="30"
       alt=""
     />
     <span class="cls_filter"> {{ 'component.apps.filter.filters' | translate }} </span>
   </div>
 </div>
</div>
 <h4 class ="clsCard_Subtitle filterOptions" >
  {{'component.security.sub-title' | translate }}
</h4>
 <div *ngIf="showAllFilters" class="row clsFilters" >
  <div class="col-md-7 col-lg-3 col-xl-4 srchBar" >
    <form class="form-inline">
      <input
        type="text"
        class="form-control"
        id="txtSearch"
        name="txtSearch"
        [(ngModel)]="txtSearch"
        placeholder="{{
          'component.security.placeholder-search' | translate
        }}"
        (click)="filterFindings()"
      />

      <button type="button" (click)="filterFindings()">
        <img
          src="../../../../assets/images/icons/magnifying_glass_detail.png"
          width="16"
          height="16"
          alt=""
        />
        {{ 'component.common.search' | translate | uppercase }}
      </button>
    </form>
  </div>

  <div
    class="selector selectPlatform " 
    [ngClass]="{ 'form-inline': pWidth >960 }"
  >
  
    <div class="clsFilterTitle">
      {{ 'component.apps.filter.platform' | translate }}
    </div>
    <ng-select
      class="clsSelect platform TextBold"
      [(ngModel)]="platform"
      [searchable]="false"
      [clearable]="false"
      [placeholder]="'component.common.all' | translate "
      (change)="filterFindings()"   
    >
      <ng-option
        *ngFor="let item of filterPlatform"
        [value]="item.value"
      >
        {{ item.name }}
      </ng-option>
    </ng-select>
  </div>

  <div
    class=" col-md-6 col-lg-4  selector selectDates"
    [ngClass]="{ 'form-inline': pWidth >960 }"
  >
  
    <div class="clsFilterTitle">
      {{ 'component.apps.filter.dates' | translate }}
    </div>
    <ng-select
      class="clsSelect dates TextBold"
      [(ngModel)]="dateFilter"
      [searchable]="false"
      [clearable]="false"
      [placeholder]="'component.common.all' | translate "
      (change)="filterFindings()"   
    >
      <ng-option
        *ngFor="let item of filterDates"
        [value]="item.value"
      >
        {{ item.name }}
      </ng-option>
    </ng-select>
  </div>
  
  
</div>
</div>

   <table
  mat-table
  [dataSource]="dataSource" 
  matSort
  matSortActive="severity"
  matSortDirection="desc"
  multiTemplateDataRows
  class="mat-elevation-z8 no-wrap v-middle"
>
<ng-container matColumnDef="since">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    class="clsTblHeader clsTblHeadDate elipsis"
  >
    {{ 'component.security.comments.since' | translate }}
  </th>
  <td
    mat-cell
    *matCellDef="let item" 
    class="clsValue elipsis"
  >
    <div class="row pl-3">
      {{ (item.since  | date: 'dd-MMM-yy') }}
    </div>
  </td>
</ng-container>

<ng-container matColumnDef="last">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    class="clsTblHeader clsTblHeadDate elipsis"
  >
    {{ 'component.security.comments.last' | translate }}
  </th>
  <td
    mat-cell
    *matCellDef="let item" 
    class="clsValue elipsis"
  >
    <div class="row pl-3">
      {{ (item.last  | date: 'dd-MMM-yy') }}
    </div>
  </td>
</ng-container>

<ng-container matColumnDef="severity">
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    class="clsTblHeader clsTblHeadDate elipsis"
  >
    {{ 'component.security.comments.severity' | translate }}
  </th>
  <td
    mat-cell
    *matCellDef="let item" 
    class="clsValue elipsis"
  >
    <div class="row pl-3">
      
  <div
  class="clsGrid_dot clsGrid_dotSF_Status"
  [ngClass]="getClsSeverity(item.finding.severity)">
  </div>

      {{ item.finding.severity  | capitalLetter}}
    </div>
  </td>
</ng-container>

<ng-container matColumnDef="title" >
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    class="clsTblHeader clsTblHeadTitle elipsis"
  >
    {{ 'component.security.comments.title' | translate }}
  </th>
  <tr
      mat-row
      *matRowDef="let row; columns: ['blankRow']"
      class="blank-row"
    ></tr>

     <td
      mat-cell
      *matCellDef="let item"
      class="clsValue elipsis"
    >
      <span title="{{ item.title | capitalLetter }}">{{
        item.finding.title
      }}</span>
    </td>
</ng-container>

<ng-container matColumnDef="appName" >
  <th
    mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    class="clsTblHeader clsTblHeadView elipsis"
  >
    {{ 'component.security.comments.name' | translate }}
  </th>
  <tr
      mat-row
      *matRowDef="let row; columns: ['blankRow']"
      class="blank-row"
    ></tr>

     <td
      mat-cell
      *matCellDef="let item"
      class="clsValue elipsis"
    >
      <span title="{{ item.title | capitalLetter }}">{{
        item.app.name
      }}</span>
    </td>
</ng-container>

<ng-container matColumnDef="platform" >
  <th
  mat-header-cell
  *matHeaderCellDef
  mat-sort-header
  class="clsTblHeader clsTblHeadView elipsis"
>
  {{ 'component.security.comments.platform'  | translate }}
</th>
  <tr
      mat-row
      *matRowDef="let row; columns: ['blankRow']"
      class="blank-row"
    ></tr>

     <td
      mat-cell
      *matCellDef="let item"
      class="clsValue elipsis"
    >
      <span title="{{ item.title | capitalLetter }}">
     
        <img
        alt=""
        width="30"
        height="30"
        [src]="
        item.app.technology === 'android'
            ? '../../../../assets/images/assets/android.png'
            : '../../../../assets/images/assets/ios.png'
        "
      />
        
      </span>
    </td>
</ng-container>

<ng-container matColumnDef="actions" >
  <th
  mat-header-cell
  *matHeaderCellDef
  class="clsTblHeader clsTblHeadView elipsis"
  >
{{ 'component.security.comments.actions' | translate }} 
</th>
  <tr
      mat-row
      *matRowDef="let row; columns: ['blankRow']"
      class="blank-row"
    ></tr>
   
    <td mat-cell *matCellDef="let item" 
    class="clsValue elipsis" >
   <div class="redirectDiv" >
      <a [href]="this.goToFinding(item)"  target="_blank">
        <img [src]="linkIcon"
        width="20"
        height="20"
        [matTooltip]="'component.security.tooltip.go-to-finding' | translate" matTooltipClass ="customToolTipClass" matTooltipPosition="below"  
         alt="Image">
      </a>
    </div>
      <img
        [src]="item.finding.rldIcn ? item.finding.rldIcn : closeTargetIcon"
        width="20"
        height="20"
        alt=""
        class="clsCursorPointer detailFinding"
        [matTooltip]="'component.security.tooltip.close-finding' | translate" matTooltipClass ="customToolTipClass"  matTooltipPosition="below" 

        (click)="this.openFindingDetailDialog(item, item.finding.id)"
      />
    </td>
</ng-container>

<ng-container matColumnDef="blankRow">
  <td mat-cell *matCellDef="let item" [attr.colspan]="tblCols.length"></td>
</ng-container>

<tr mat-header-row *matHeaderRowDef="tblCols"></tr>
<tr
  mat-row
  *matRowDef="let item; columns: tblCols"
  class="expandable-row mat-row-height"
></tr>

</table>
<hr />
<mat-paginator
  [length]="findingsNumber"
  [pageSize]="10"
  [pageSizeOptions]="[5, 10, 25, 100]"
></mat-paginator>
